<div class="wrapper">
    <div class="icon">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2" class="status">
            <circle
                class="path circle"
                fill="none"
                stroke="#fff"
                stroke-width="6"
                stroke-miterlimit="10"
                cx="65.1"
                cy="65.1"
                r="62.1"
            />
            <line
                class="path line"
                fill="none"
                stroke="#fff"
                stroke-width="6"
                stroke-linecap="round"
                stroke-miterlimit="10"
                x1="34.4"
                y1="37.9"
                x2="95.8"
                y2="92.3"
            />
            <line
                class="path line"
                fill="none"
                stroke="#fff"
                stroke-width="6"
                stroke-linecap="round"
                stroke-miterlimit="10"
                x1="95.8"
                y1="38"
                x2="34.4"
                y2="92.2"
            />
        </svg>
    </div>

    <div class="content">
        <h2>Your payment could not be processed</h2>
        <p>
            Double check all of your information and re-submit once corrected. If you continue to have problems, you may
            need to contact your financial institution to troubleshoot.
        </p>
    </div>
</div>
